import { useStoreState } from 'providers/StoreStateContext';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

export default function PublicRoute() {
  const { token } = useStoreState();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate('/');
    }
  }, [token]);

  return <Outlet />;
}
